module.exports = __webpack_public_path__ + "093a8c02b3acfafc7b1a2b25d57f9dac.svg";